import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import Logger from 'components/common/helpers/devConsoleLog';
import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken as getTokenFromFirebase,
  Messaging,
  onMessage,
  deleteToken,
} from 'firebase/messaging';

// TODO API key to env
const apiKey = 'AIzaSyD4nEjFYnU1gdJGaMj6THx2NAX-Z9Osqgo';

class MobileService {
  public isMobile = false;

  private isSafari!: boolean;

  private messaging!: Messaging;

  private mobileToken!: string;

  private currentPermission!: string;

  constructor() {
    this.init();
  }

  private init() {
    this.isMobile = Capacitor.isNativePlatform();

    const initializer = this.isMobile
      ? () => this.initMobile()
      : () => this.initWeb();
    initializer();
  }

  private initWeb() {
    // FCM doesn't work for Safari
    if (navigator.vendor.match(/apple/i)) {
      Logger('Safari detected. Skipping web push notifications init.');
      this.isSafari = true;
      return;
    }

    // firebase
    const app = initializeApp({
      apiKey,
      authDomain: 'aneta-ed.firebaseapp.com',
      databaseURL: 'https://aneta-ed-default-rtdb.firebaseio.com',
      projectId: 'aneta-ed',
      storageBucket: 'aneta-ed.appspot.com',
      messagingSenderId: '709973661069',
      appId: '1:709973661069:web:ff448ad3d32d06444559c4',
      measurementId: 'G-074F0B8L5B',
    });

    this.messaging = getMessaging(app);

    onMessage(this.messaging, (msg) => Logger('Received push', msg));
  }

  async requestPermWeb(): Promise<string> {
    if (!window.Notification) {
      return '';
    }

    const shouldAsk =
      window.Notification.permission !== 'granted' &&
      window.Notification.requestPermission;

    if (shouldAsk) {
      const p = await window.Notification.requestPermission();
      this.currentPermission = p;
      return p;
    }

    if (!this.currentPermission && window.Notification.permission) {
      this.currentPermission = window.Notification.permission;
    }

    return this.currentPermission || '';
  }

  public async requestPermissions(): Promise<string | undefined> {
    try {
      if (this.currentPermission) {
        return Promise.resolve(this.currentPermission);
      }

      const perm = this.isMobile
        ? (await PushNotifications.requestPermissions()).receive
        : await this.requestPermWeb();

      if (perm) {
        this.currentPermission = perm;
      }

      return perm;
    } catch (err) {
      return undefined;
    }
  }

  private async initMobile() {
    try {
      const permissions = await PushNotifications.requestPermissions();

      if (permissions.receive === 'granted') {
        PushNotifications.register();

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        PushNotifications.addListener('registration', (token: any) => {
          // alert(`Push registration success, token: ${token.value}`);
          Logger('Push registration success, token:', token.value);
          this.mobileToken = token.value;
        });

        PushNotifications.addListener('registrationError', (res) => {
          // alert(`Push registration success, token: ${token.value}`);
          Logger('Push registration error:', res);
        });

        PushNotifications.addListener(
          'pushNotificationReceived',
          (notification) => {
            Logger('Push received:', notification);
          }
        );
      }
    } catch (err) {
      MobileService.onError();
    }
  }

  public getToken() {
    return this.isMobile
      ? Promise.resolve(this.mobileToken)
      : this.getWebToken();
  }

  private getWebToken() {
    return this.isSafari
      ? Promise.resolve(null)
      : getTokenFromFirebase(this.messaging);
  }

  public deleteWebToken() {
    return deleteToken(this.messaging);
  }

  private static onError() {
    // TODO global warning
  }
}

const instance = new MobileService();
export default instance;
